import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { addPermissionRefs } from '../../../core/components/UserGroupPermissions';
import DataTable from '../../../core/components/DataTable';
import { useDispatch, useSelector } from 'react-redux';
import { selectInventoryTypes } from '../reducer';
import { archiveInventoryType } from '../actions';
import moment from 'moment';
import PageActions from '../../../core/components/PageActions';
import AddInventoryTypeFormWrapper from '../containers/AddInventoryTypeDialog';
import { showDialog, hideDialog } from '../../../core/actions';
import TableActionButtonsCell from '../../../core/components/TableActionButtonsCell';
import { hasRole } from '../../../core/components/Permission';
import { selectRole } from '../../../store/authReducer';

const InventoryTypeTable = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const inventoryTypes = useSelector(selectInventoryTypes);
  const role = useSelector(selectRole);

  const archiveInventoryTypeAction = (event, { _id, name }) => {
    const confirmProps = {
      onReady: () => {
        dispatch(archiveInventoryType({ id: _id }));
      },
      text: intl.formatMessage({ id: 'archiveInventoryTypeConfirmation' }, { name }),
      title: intl.formatMessage({ id: 'archiveInventoryType' }),
    };
    dispatch(showDialog('CONFIRM_DIALOG', confirmProps));
  };

  const initializeActionButtonHeader = () => {
    const actionButtonHeader = {
      name: intl.formatMessage({ id: 'actions' }),
      cell: {
        component: TableActionButtonsCell,
        mixIns: {
          buttons: [],
        },
      },
    };

    if (hasRole(role, 'OperatorAdmin')) {
      actionButtonHeader.cell.mixIns.buttons.push({
        icon: 'icon-trash',
        buttonAction: archiveInventoryTypeAction,
      });
    }
    return actionButtonHeader;
  };

  const initializeDatatable = () => {
    const data = inventoryTypes?.map((type) => ({
      _id: type.id,
      name: type.name,
      createdAt: moment(type.createdAt).format('MM/DD/YYYY'),
      archivedAt: type.archivedAt ? moment(type.archivedAt).format('MM/DD/YYYY') : '',
    }));
    const headers = [
      { name: intl.formatMessage({ id: 'name' }), databaseProperty: 'name' },
      { name: intl.formatMessage({ id: 'createdAt' }), databaseProperty: 'createdAt' },
      { name: intl.formatMessage({ id: 'archivedAt' }), databaseProperty: 'archivedAt' },
    ];
    if (hasRole(role, 'OperatorAdmin')) {
      headers.push(initializeActionButtonHeader());
    }

    return { headers, data };
  };

  const actionFunction = (dialogType, dialogProps) => {
    dispatch(showDialog(dialogType, dialogProps));
  };

  const getPageActions = () => {
    const callback = () => {
      return fetchInventoryTypes();
    };
    return [
      {
        dialogType: 'CONFIRM_DIALOG',
        permissionKey: addPermissionRefs.inventory,
        text: intl.formatMessage({ id: 'addInventoryType' }),
        dialogProps: {
          specificComponent: AddInventoryTypeFormWrapper,
          isNew: true,
          callback,
          hideDialog: () => {
            dispatch(hideDialog());
          },
          title: intl.formatMessage({ id: 'addInventoryType' }),
        },
      },
    ];
  };

  return (
    <div>
      <section>
        <div className="filters-actions-container right-align">
          <PageActions actionFunction={actionFunction} actions={getPageActions()} />
        </div>
      </section>
      <section className="inventory">
        <div>
          <DataTable {...initializeDatatable()} scrolling />
        </div>
      </section>
    </div>
  );
};

export default InventoryTypeTable;
